(() => {
  if (window.compareTheCollectionInitialized) return;

  window.compareTheCollectionInitialized = true;

  class CompareTheCollection {
    constructor(section) {
      this.section = section;

      this.prevButton = section.querySelector(".compare-carousel__prev");
      this.nextButton = section.querySelector(".compare-carousel__next");
      this.dots = [...section.querySelectorAll(".carousel-dot")];
      this.status = section.querySelector(".compare-carousel__status");

      this.productNames = [
        ...section.querySelectorAll(".compare-the-collection__product-name"),
      ].map((name) => name.textContent.replace(/\s+/g, " ").trim());

      this.totalColumns = 3;
      this.activeColumn = 1;

      if (!this.prevButton || !this.nextButton) return;

      this.prevButton.addEventListener("click", () => {
        this.changeColumn(-1);
      });

      this.nextButton.addEventListener("click", () => {
        this.changeColumn(1);
      });

      this.update();
    }

    changeColumn(direction) {
      this.activeColumn += direction;

      if (this.activeColumn < 1) {
        this.activeColumn = this.totalColumns;
      }

      if (this.activeColumn > this.totalColumns) {
        this.activeColumn = 1;
      }

      this.update(true);
    }

    update(announce = false) {
      this.section.dataset.activeColumn = this.activeColumn;

      this.dots.forEach((dot, index) => {
        dot.classList.toggle("is-active", index === this.activeColumn - 1);
      });

      if (announce && this.status) {
        const productName = this.productNames[this.activeColumn - 1];

        this.status.textContent = `${productName}, mattress ${this.activeColumn} of ${this.totalColumns}`;
      }
    }
  }

  const initCompareTheCollection = (container = document) => {
    const initSection = (section) => {
      if (section.dataset.compareInitialized === "true") return;

      section.dataset.compareInitialized = "true";
      new CompareTheCollection(section);
    };

    if (container.matches?.(".compare-the-collection")) {
      initSection(container);
    }

    container.querySelectorAll(".compare-the-collection").forEach(initSection);
  };

  const init = () => {
    initCompareTheCollection();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  /*
   * Reinitialize if Shopify reloads the section inside
   * the theme customizer.
   */
  document.addEventListener("shopify:section:load", (event) => {
    initCompareTheCollection(event.target);
  });
})();
